import { render, staticRenderFns } from "./PlaceDetails.vue?vue&type=template&id=04ba8d78&scoped=true"
import script from "./PlaceDetails.vue?vue&type=script&lang=js"
export * from "./PlaceDetails.vue?vue&type=script&lang=js"
import style0 from "./PlaceDetails.vue?vue&type=style&index=0&id=04ba8d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba8d78",
  null
  
)

export default component.exports